import type { User } from 'vl-common/src/schemas/shared';
import { PolicySchema } from 'vl-common/src/schemas/shared/policy';
import { z } from 'zod';
import { vlFetch } from 'vl-common/src/init/vlFetch';

// The user has just authenticated, but we don't know if it's because they've refreshed,
// returned from an OAuth redirect or just processed their MFA.
export async function initialAuthenticatedRoute(redirectUrl: URL, user: User) {
  const { user_type_code, self_reg_required, new_policies } = user;

  const changePage = (newPage: string) => {
    const { search, hash } = window.location;

    return newPage + search + hash;
  };

  if (self_reg_required) return changePage('/create-account');
  if (new_policies) return changePage('/policy');

  if (user_type_code === 'PATIENT') {
    const { polcies: policies } = await vlFetch('users/policy/APPUSER', z.object({ polcies: z.array(PolicySchema) }));

    if (policies.some((p) => !p.accepted)) return changePage('/policy');

    return changePage('/patients');
  }

  if (user_type_code === 'CLINICIAN') return changePage('/clinician');

  return changePage(redirectUrl.pathname);
}
